




























import { EpigraphicUnitSide } from '@oare/types';
import { defineComponent, PropType } from '@vue/composition-api';
import SideSelector from './SideSelector.vue';

export default defineComponent({
  props: {
    usableSides: {
      type: Array as PropType<EpigraphicUnitSide[]>,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
  },
  components: {
    SideSelector,
  },
  setup() {
    return {};
  },
});
